/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeriesValueObjectDTO } from './SeriesValueObjectDTO';
import {
    SeriesValueObjectDTOFromJSON,
    SeriesValueObjectDTOFromJSONTyped,
    SeriesValueObjectDTOToJSON,
} from './SeriesValueObjectDTO';
import type { SingleTimeSeriesViewBucket } from './SingleTimeSeriesViewBucket';
import {
    SingleTimeSeriesViewBucketFromJSON,
    SingleTimeSeriesViewBucketFromJSONTyped,
    SingleTimeSeriesViewBucketToJSON,
} from './SingleTimeSeriesViewBucket';

/**
 * 
 * @export
 * @interface Point
 */
export interface Point {
    /**
     * 
     * @type {SingleTimeSeriesViewBucket}
     * @memberof Point
     */
    bucket?: SingleTimeSeriesViewBucket;
    /**
     * 
     * @type {boolean}
     * @memberof Point
     */
    interpolation: boolean;
    /**
     * 
     * @type {SeriesValueObjectDTO}
     * @memberof Point
     */
    object?: SeriesValueObjectDTO;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    step?: number;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    timestampMillis?: number;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    x: number;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    y?: number;
}

/**
 * Check if a given object implements the Point interface.
 */
export function instanceOfPoint(value: object): value is Point {
    if (!('interpolation' in value) || value['interpolation'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    return true;
}

export function PointFromJSON(json: any): Point {
    return PointFromJSONTyped(json, false);
}

export function PointFromJSONTyped(json: any, ignoreDiscriminator: boolean): Point {
    if (json == null) {
        return json;
    }
    return {
        
        'bucket': json['bucket'] == null ? undefined : SingleTimeSeriesViewBucketFromJSON(json['bucket']),
        'interpolation': json['interpolation'],
        'object': json['object'] == null ? undefined : SeriesValueObjectDTOFromJSON(json['object']),
        'step': json['step'] == null ? undefined : json['step'],
        'timestampMillis': json['timestampMillis'] == null ? undefined : json['timestampMillis'],
        'x': json['x'],
        'y': json['y'] == null ? undefined : json['y'],
    };
}

export function PointToJSON(value?: Point | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bucket': SingleTimeSeriesViewBucketToJSON(value['bucket']),
        'interpolation': value['interpolation'],
        'object': SeriesValueObjectDTOToJSON(value['object']),
        'step': value['step'],
        'timestampMillis': value['timestampMillis'],
        'x': value['x'],
        'y': value['y'],
    };
}

